export default {
	/**
	 * @description 配置显示在浏览器标签的title
	 */
	title: '途灵物流',
	/**
	 * @description api请求基础路径
	 */
	baseUrl: {
		dev: '/api/',
		pro: 'https://tuwotop.com/api/',
	},

	//文件预览地址
	fileViewUrl: {
		dev: 'https://tuwotop.com/dev/',
		pro: 'https://tuwotop.com/'
	},
	pageSize: 10,

	//json转query查询参数
	jsonToQueryParams: obj => {
		let queryParams = ''
		for (const key in obj) {
			if (obj.hasOwnProperty(key)) {
				queryParams += `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}&`
			}
		}
		queryParams = queryParams.slice(0, -1) // 去除最后一个多余的&
		return queryParams
	}
}





